var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 215,
    height: 219,
    viewBox: "0 0 215 219",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_94",
    x: 0,
    y: 5,
    width: 215,
    height: 214,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 4,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffd991"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(1.146 0.474)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_93",
    "data-name": "Ellipse 93",
    cx: 107,
    cy: 107,
    r: 107,
    transform: "translate(-0.146 -0.474)",
    fill: "#c9922b"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -1.15, -0.47)",
    filter: "url(#Ellipse_94)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_94-2",
    "data-name": "Ellipse 94",
    cx: 98.5,
    cy: 98,
    rx: 98.5,
    ry: 98,
    transform: "translate(9 10)",
    fill: "#c9922b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Check",
    transform: "translate(66.655 75.045)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Check-2",
    "data-name": "Check",
    d: "M80.758,11.972a4.688,4.688,0,0,0,0-6.6,4.609,4.609,0,0,0-6.556,0L25.268,54.648,9.916,39.193a4.609,4.609,0,0,0-6.556,0,4.687,4.687,0,0,0,0,6.6l18.4,18.532c.074.08.144.159.223.233a4.626,4.626,0,0,0,6.57,0,2.662,2.662,0,0,0,.223-.238Z",
    transform: "translate(-2 -4)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.416a24b87023a733d8dd96a150753f10.svg";
export { ForwardRef as ReactComponent };